export const projects = [
    {
      title: "Load Animation",
      description:
        "Load animation is a visual effect where elements on a page move or change as the user scrolls or user load the page, creating an interactive and engaging experience.",
      link: "/load-animation",
      visible : true,
      isNew : false
    },
    {
      title: "Hover Animation",
      description:
        "Hover animation is a visual effect where elements on a page change or move when the user hovers over them, enhancing interactivity and user engagement.",
      link: "/hover-animation",
      visible : true,
      isNew : false
    },
    {
      title: "Active Component",
      description:
        "Active component animation is a visual effect that highlights or changes an element when it is actively interacted with, such as being clicked or focused, enhancing user experience and feedback.",
      link: "/active-component",
      visible : true,
      isNew : false
    },
    {
      title: "Page Transition",
      description:
        "Page transition animation is a visual effect that transitions between pages or sections of a website, creating a smooth and seamless experience for the user.",
      link: "/page-transition",
      visible : true,
      isNew : true
    },
    {
      title: "Drag and Drop",
      description:
        "Drag and drop animation is a visual effect where elements on a page can be dragged and dropped, creating a dynamic and interactive experience for the user.",
      link: "https://amazon.com",
      visible : false,
      isNew : false
    },
    {
      title: "Infinite Animation",
      description:
        "Infinite animation is a visual effect where elements on a page repeat or cycle indefinitely, creating a dynamic and engaging experience for the user.",
      link: "https://microsoft.com",
      visible : false,
      isNew : false
    },
  ];